import React, { useState } from "react";
import ArrowBlackUp from '../../assets/img/arrow_black_up.png';
import ArrowBlackDown from '../../assets/img/arrow_black_down.png';
import Translation from "../../services/translation.service";
import ProgressStepperStep from "./protection-channel-progress-step.component";

export default function ProgressStepper({ info }) {
    let prefix = "scr_protection_channel";
    const [showsteps, setShowSteps] = useState(true);
    
    const toggleStepper = () => {
        setShowSteps((showsteps) => !showsteps);
    }

    return (
    <div className="complaint-step-progress">
        <div className="complaint-title" onClick={()=> toggleStepper()}>{Translation.keys[prefix + "_report_spam"]}<img src={showsteps ? ArrowBlackUp : ArrowBlackDown} alt="arrow"/></div>
        {showsteps && <div className="complaint-steps-block">
            <ProgressStepperStep
                title={Translation.keys[prefix + "_your_number"]}
                subtitle={Translation.keys[prefix + "_start_with_msisdn"]}
                step="1"
                info={info?.step1?.status}
            />
            <ProgressStepperStep
                title={Translation.keys[prefix + "_report_spam"]}
                subtitle={Translation.keys[prefix + "_enter_your_data"]}            
                step="2" 
                info={info?.step2?.status}
            />        
            <ProgressStepperStep                 
                title={Translation.keys[prefix + "_confirmation"]}
                subtitle={Translation.keys[prefix + "_you_can_follow"]}            
                step="3"
                info={info?.step3?.status}
            />
        </div>
        }
    </div>
    );
}